// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.withdrawal-page {
    max-width: 1320px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: 'Noto Sans KR', sans-serif;
}

.wp-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 60px;
}

.wp-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.withdrawal-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 60px 0;
    text-align: center;
}

.withdrawal-container.centered {
    padding-top: 120px;
    padding-bottom: 120px;
}


.withdrawal-title {
    font-size: 28px;
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: 40px;
}

.withdrawal-info {
    font-size: 16px;
    color: #555;
    background-color: #f8f8f8;
    padding: 40px;
    text-align: left;
    line-height: 1.8;
    margin-bottom: 60px;
}

.withdrawal-info p {
    margin: 0 0 10px 0;
}

.withdrawal-container.centered .withdrawal-info {
    background-color: transparent;
    text-align: center;
    padding: 0;
    margin-bottom: 40px;
}


.withdrawal-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.withdrawal-actions button {
    padding: 15px 60px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
}

.btn-cancel {
    background-color: #222;
    color: white;
    border: none;
}

.btn-withdraw {
    background-color: #E84100;
    color: white;
    border: none;
}

.btn-home {
    background-color: #222;
    color: white;
    border: none;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .withdrawal-page {
        padding: 20px;
    }

    .withdrawal-container {
        padding: 40px 0;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .withdrawal-page {
        padding: 15px;
    }

    .wp-breadcrumb {
        font-size: 12px;
        margin-bottom: 30px;
    }
    
    .withdrawal-container {
        padding: 20px 0;
    }

    .withdrawal-title {
        font-size: 22px;
    }

    .withdrawal-info {
        padding: 20px;
        font-size: 14px;
        margin-bottom: 40px;
    }

    .withdrawal-actions {
        flex-direction: column;
        gap: 10px;
    }

    .withdrawal-actions button {
        width: 100%;
        padding: 15px;
        font-size: 16px;
    }

    .withdrawal-container.centered {
        padding: 60px 0;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/WithdrawalPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".withdrawal-page {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 40px 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.wp-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 60px;\n}\n\n.wp-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.withdrawal-container {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 60px 0;\n    text-align: center;\n}\n\n.withdrawal-container.centered {\n    padding-top: 120px;\n    padding-bottom: 120px;\n}\n\n\n.withdrawal-title {\n    font-size: 28px;\n    font-weight: 500;\n    line-height: 1.5;\n    margin-bottom: 40px;\n}\n\n.withdrawal-info {\n    font-size: 16px;\n    color: #555;\n    background-color: #f8f8f8;\n    padding: 40px;\n    text-align: left;\n    line-height: 1.8;\n    margin-bottom: 60px;\n}\n\n.withdrawal-info p {\n    margin: 0 0 10px 0;\n}\n\n.withdrawal-container.centered .withdrawal-info {\n    background-color: transparent;\n    text-align: center;\n    padding: 0;\n    margin-bottom: 40px;\n}\n\n\n.withdrawal-actions {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n\n.withdrawal-actions button {\n    padding: 15px 60px;\n    font-size: 18px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.btn-cancel {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-withdraw {\n    background-color: #E84100;\n    color: white;\n    border: none;\n}\n\n.btn-home {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .withdrawal-page {\n        padding: 20px;\n    }\n\n    .withdrawal-container {\n        padding: 40px 0;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .withdrawal-page {\n        padding: 15px;\n    }\n\n    .wp-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 30px;\n    }\n    \n    .withdrawal-container {\n        padding: 20px 0;\n    }\n\n    .withdrawal-title {\n        font-size: 22px;\n    }\n\n    .withdrawal-info {\n        padding: 20px;\n        font-size: 14px;\n        margin-bottom: 40px;\n    }\n\n    .withdrawal-actions {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .withdrawal-actions button {\n        width: 100%;\n        padding: 15px;\n        font-size: 16px;\n    }\n\n    .withdrawal-container.centered {\n        padding: 60px 0;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
